/** Returns the item at an index that wraps around the list, so every number picks one. */
export function cycle<List extends readonly [unknown, ...unknown[]]>(items: List, index: number): List[number] {
  return items[Math.abs(index) % items.length] ?? items[0];
}
